export default __webpack_public_path__ + "static/media/regulatory--no-pedestrians-or-bicycles--g1.4a8441a7.png";